module.exports = __webpack_public_path__ + "img/bg.5e2f56b8.png";